module.exports = __webpack_public_path__ + "cat_food.svg?6d808cc29c6a1436f1841d81f4922f67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat_icons/cat_food.svg
// module id = 113
// module chunks = 0